<template>
  <div>
    <v-autocomplete
      :value="currency"
      :items="filterCurrencies"
      :label="label"
      @change="changedTo"
      ref="select"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :multiple="multiple"
      :search-input.sync="filter"
      autocomplete="nope"
      :no-filter="true"
    >
      <template v-slot:selection="data">
        <div v-if="multiple === '' || multiple">
          <div
            class="v-chip--select v-chip v-chip--clickable v-chip--no-color theme--light v-size--default"
          >
            {{ data.item.name }}
            <v-icon @click="remove(data.item)">mdi-close</v-icon>
          </div>
        </div>
        <div v-else>
          <div ripple class="height32">
            <h5 class="text-title">{{ data.item.name }}</h5>
          </div>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }} - {{ data.item.fullName }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "CurrencySelect",
  props: {
    value: {
      default: false,
    },
    label: {
      default: "Currency",
    },
    clearable: {
      default: false,
    },
    multiple: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class CurrencySelect extends (Vue, Themeable) {
  currency = null;
  currencies = [];
  loading = true;
  filter = "";

  clear() {
    this.filter = "";
    this.currency = null;
    this.$emit("input", null);
  }

  get filterCurrencies() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.currencies;
    const fc = this.currencies.filter(function (c) {
      return c.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fc;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) this.currency = newVal;
    if (Array.isArray(newVal)) {
      const response = [];
      for (let i = 0; i < newVal.length; i++) {
        response.push(newVal[i].name);
      }
      this.$emit("input", response);
    } else if (newVal && newVal.name) {
      this.$emit("input", newVal.name);
      return;
    }
    if (!newVal) this.$emit("input", null);
  }

  setDefault() {
    if (
      (this.value &&
        this.currencies != null &&
        this.currencies.length > 0 &&
        this.multiple != "") ||
      this.multiple === false
    ) {
      for (let i = 0; i < this.currencies.length; i++) {
        if (this.currencies[i].name === this.value) {
          this.currency = this.currencies[i];
          break;
        }
      }
    } else if (this.currencies != null && this.currencies.length > 0) {
      this.currency = [];
      if (
        this.value != null &&
        this.value != "" &&
        this.currencies.length > 0
      ) {
        for (let i = 0; i < this.currencies.length; i++) {
          if (
            this.value.filter((e) => e === this.currencies[i].name).length > 0
          ) {
            this.currency.push(this.currencies[i]);
          }
        }
      }
    }
  }

  async mounted() {
    await common.populateCurrencies();
    this.currencies = common.currencies;
    this.setDefault();
    this.loading = false;
  }

  selected(val) {
    if (val != null && val.name != null && this.currency != null) {
      if (Array.isArray(this.currency)) {
        for (let i = 0; i < this.currency.length; i++) {
          if (val.name === this.currency[i].name) {
            return true;
          }
        }
      } else if (this.currency != null && this.currency.name != undefined) {
        if (val.name === this.currency.name) {
          return true;
        }
      }
    }
    return false;
  }

  remove(val) {
    if (val != null && val.name != null && this.currency != null) {
      if (Array.isArray(this.currency)) {
        for (let i = 0; i < this.currency.length; i++) {
          if (val.name === this.currency[i].name) {
            this.currency.splice(i, 1);
            const response = [];
            for (let i = 0; i < this.currency.length; i++) {
              response.push(this.currency[i].name);
            }
            this.$emit("input", response);
            break;
          }
        }
      }
    }
    return false;
  }

  @Watch("value")
  async onValueChange() {
    if (this.value == "") {
      this.currency = null;
    }
    await common.populateCurrencies();
    this.currencies = common.currencies;
    this.setDefault();
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.flag-img {
  float: left;
  margin-right: 10px;
  height: 20px;
  width: 24px;
  margin: 5px 10px 2px 0;
}
</style>
